const DocumentTypes = {
  CPF: 1,
  CNPJ: 2,
  ID: 3,
  PASSPORT: 4,
  OTHER: 5
};

export default DocumentTypes;
